import React from 'react';
import { FaReact, FaNodeJs, FaDatabase, FaHtml5, FaCss3Alt, FaJsSquare, FaBootstrap, FaPhp, FaJava, FaPython, FaLaravel, FaGithub, FaGit, FaAws, FaCode, FaTools, FaSass, FaLinux, FaWindows } from 'react-icons/fa';
import { FaC } from 'react-icons/fa6';
import { SiNextdotjs, SiRedux, SiMui, SiTailwindcss, SiFlutter, SiDart, SiMongodb, SiFirebase, SiPostman, SiVisualstudiocode, SiCplusplus, SiExpress, SiFigma, SiGooglecolab } from 'react-icons/si';
import { TbBrandReactNative } from 'react-icons/tb';

const Skills = () => {
  const skills = [
    {
      category: 'Languages and Frameworks',
      icon: <FaCode />,
      items: [
        { icon: <FaHtml5 />, name: 'HTML5' },
        { icon: <FaCss3Alt />, name: 'CSS3' },
        { icon: <FaJsSquare />, name: 'JavaScript' },
        { icon: <FaReact />, name: 'React.js' },
        { icon: <TbBrandReactNative />, name: 'React-Native' },
        { icon: <SiNextdotjs />, name: 'Next.js' },
        { icon: <SiRedux />, name: 'Redux' },
        { icon: <FaBootstrap />, name: 'Bootstrap' },
        { icon: <SiMui />, name: 'MUI' },
        { icon: <SiTailwindcss />, name: 'Tailwind' },
        { icon: <SiFlutter />, name: 'Flutter' },
        { icon: <SiDart />, name: 'Dart' },
        { icon: <FaSass />, name: 'Dart' },
        { icon: <FaLaravel />, name: 'Laravel' }
      ]
    },
    {
      category: 'Other Languages',
      icon: <FaCode />,
      items: [
        { icon: <FaPhp />, name: 'PHP' },
        { icon: <SiCplusplus />, name: 'C++' },
        { icon: <FaPython />, name: 'Python' },
        { icon: <FaJava />, name: 'Java' },
        { icon: <FaC />, name: 'C' }
      ]
    },
    {
      category: 'Backend',
      icon: <FaCode />,
      items: [
        { icon: <FaNodeJs />, name: 'Node.js' },
        { icon: <SiExpress />, name: 'Express.js' }
      ]
    },
    {
      category: 'Clouds & Databases',
      icon: <FaDatabase />,
      items: [
        { icon: <SiMongodb />, name: 'MongoDB' },
        { icon: <SiFirebase />, name: 'Firebase' }
      ]
    },
    {
      category: 'Developer Tools',
      icon: <FaTools />,
      items: [
        { icon: <SiPostman />, name: 'Postman' },
        { icon: <SiGooglecolab />, name: 'Colab' },
        { icon: <SiFigma />, name: 'Figma' },
        { icon: <SiVisualstudiocode />, name: 'VS Code' },
        { icon: <FaGithub />, name: 'GitHub' },
        { icon: <FaGit />, name: 'Git' },
        { icon: <FaAws />, name: 'AWS' },
        { icon: <FaLinux />, name: 'Linux' }, 
        { icon: <FaWindows />, name: 'Windows' }
      ]
    }
  ];

  return (
    <div className="p-4">
      {skills.map((skillCategory, index) => (
        <div key={index} className="mb-8">
          <div className="flex items-center mb-4">
            <div className="text-2xl mr-2">{skillCategory.icon}</div>
            <h2 className="text-2xl font-semibold">{skillCategory.category}</h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {skillCategory.items.map((skill, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="text-3xl mb-2">{skill.icon}</div>
                <span>{skill.name}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Skills;
